import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Form, Row, Col, Checkbox } from 'antd';
import BaseComponent from 'components/BaseComponent';
import styledComp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';
import FormDatePicker from 'components-desktop/FormDatePicker';
import FormInput from 'components-desktop/FormInput';
import FormInputNumber from 'components-desktop/FormInputNumber';
import FormSelect from 'components-desktop/FormSelect';
import FormTextArea from 'components-desktop/FormTextArea';
import ChangeHistoriesButton from 'components-desktop/histories/ChangeHistoriesButton';
import helpers from 'misc/helpers';

const propTypes = {
  caregiver: PropTypes.object,
  form: PropTypes.object.isRequired,
};

@autobind
class CaregiverDetails extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      coordinators: [],
      teams: [],

      isSaveButtonEnable: true,
    };
  }

  componentDidMount() {
    this.id = this.parseQueryParam('id', this.props.location);
    this.getOtherDetails();
  }

  async getOtherDetails() {
    const promise1 = this.callServiceForObjects('/coordinator/get_id_names');
    const promise2 = this.callServiceForObjects('/team/get_id_names');

    const results = await Promise.all([promise1, promise2]);

    this.setState({
      coordinators: results[0],
      teams: results[1],
    });
  }

  async saveCaregiver(values) {
    try {
      this.setState({
        isSaveButtonEnable: false,
      });

      const params = {
        id: this.id,
        firstName: helpers.extraFormInputValue(values, 'firstName'),
        middleName: helpers.extraFormInputValue(values, 'middleName'),
        lastName: helpers.extraFormInputValue(values, 'lastName'),
        gender: helpers.extraFormSelectValue(values, 'gender'),
        birth: helpers.extraFormDateValue(values, 'birth'),
        race: helpers.extraFormSelectValue(values, 'race'),
        ssn: helpers.extraFormInputValue(values, 'ssn'),
        benefitCard: helpers.extraFormSelectValue(values, 'benefitCard'),
        street: helpers.extraFormInputValue(values, 'street'),
        city: helpers.extraFormInputValue(values, 'city'),
        state: helpers.extraFormSelectValue(values, 'state'),
        zipCode: helpers.extraFormInputValue(values, 'zipCode'),
        homePhone: helpers.extraFormInputValue(values, 'homePhone'),
        cellPhone: helpers.extraFormInputValue(values, 'cellPhone'),
        email: helpers.extraFormInputValue(values, 'email'),
        coordinatorId: helpers.extraFormSelectValue(values, 'coordinatorId'),
        teamId: helpers.extraFormSelectValue(values, 'teamId'),
        pickupTeam: helpers.extraFormInputValue(values, 'pickupTeam'),
        paymentMethod: helpers.extraFormSelectValue(values, 'paymentMethod'),
        maritalStatus: helpers.extraFormSelectValue(values, 'maritalStatus'),
        allowance: helpers.extraFormInputValue(values, 'allowance'),
        multipleJob: helpers.extraFormSelectValue(values, 'multipleJob'),
        dependent: helpers.extraFormInputNumberValue(values, 'dependent'),
        otherIncome: helpers.extraFormInputNumberValue(values, 'otherIncome'),
        deductAmount: helpers.extraFormInputNumberValue(values, 'deductAmount'),
        i9Type: helpers.extraFormInputValue(values, 'i9Type'),
        i9ExpireDate: helpers.extraFormDateValue(values, 'i9ExpireDate'),
        remark: helpers.extraFormTextAreaValue(values, 'remark'),
        physicalExamDate: helpers.extraFormDateValue(values, 'physicalExamDate'),
        ppd1Date: helpers.extraFormDateValue(values, 'ppd1Date'),
        ppd1: helpers.extraFormInputValue(values, 'ppd1'),
        ppd2Date: helpers.extraFormDateValue(values, 'ppd2Date'),
        ppd2: helpers.extraFormInputValue(values, 'ppd2'),
        bloodTestDate: helpers.extraFormDateValue(values, 'bloodTestDate'),
        bloodTest: helpers.extraFormInputValue(values, 'bloodTest'),
        cxrReportDate: helpers.extraFormDateValue(values, 'cxrReportDate'),
        cxrReport: helpers.extraFormInputValue(values, 'cxrReport'),
        drugTestDate: helpers.extraFormDateValue(values, 'drugTestDate'),
        drugTest: helpers.extraFormInputValue(values, 'drugTest'),
        fluVaccineDate: helpers.extraFormDateValue(values, 'fluVaccineDate'),
        fluVaccineDeclinationDate: helpers.extraFormDateValue(values, 'fluVaccineDeclinationDate'),
        // fluVaccine: helpers.extraFormInputValue(values, 'fluVaccine'),
        // covidVaccineDate: helpers.extraFormDateValue(values, 'covidVaccineDate'),
        covidVaccine: helpers.extraFormSelectValue(values, 'covidVaccine'),
        startWorkDate: helpers.extraFormDateValue(values, 'startWorkDate'),
        endWorkDate: helpers.extraFormDateValue(values, 'endWorkDate'),
        waiting: helpers.extraFormSelectValue(values, 'waiting'),
        drive: helpers.extraFormSelectValue(values, 'drive'),
        certification: helpers.extraFormSelectValue(values, 'certification'),
        antiSexualTraining: helpers.extraFormSelectValue(values, 'antiSexualTraining'),
        orientationDate: helpers.extraFormDateValue(values, 'orientationDate'),
        inServiceTrainingDate: helpers.extraFormDateValue(values, 'inServiceTrainingDate'),
        languages: helpers.extraFormCheckboxGroupValue(values, 'languages'),
        preferAreas: helpers.extraFormCheckboxGroupValue(values, 'preferAreas'),
        preferShifts: helpers.extraFormCheckboxGroupValue(values, 'preferShifts'),
        preferEmploymentTypes: helpers.extraFormCheckboxGroupValue(values, 'preferEmploymentTypes'),
        preferDays: helpers.extraFormCheckboxGroupValue(values, 'preferDays'),
        skills: helpers.extraFormCheckboxGroupValue(values, 'skills'),
        descriptions: helpers.extraFormTextAreaValue(values, 'descriptions'),
        // noteFromCaregiver: helpers.extraFormTextAreaValue(values, 'noteFromCaregiver'),
        noteFromStaff: helpers.extraFormTextAreaValue(values, 'noteFromStaff'),
        applyStatus: helpers.extraFormSelectValue(values, 'applyStatus'),
        // applyDate: helpers.extraFormDateValue(values, 'applyDate'),
      };
      await this.callService('/caregiver/update', params);

      this.notifySuccess('Success', 'Caregiver profile has been updated.');
    } finally {
      this.setState({
        isSaveButtonEnable: true,
      });
    }
  }

  onResetClick() {
    window.location.reload();
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.saveCaregiver(values);
      }
    });
  }

  validateAtLeastOnePhone(rule, value, callback, source, options) {
    const { form } = this.props;

    if (!value) {
      const otherValue = form.getFieldValue(rule.field === 'homePhone' ? 'cellPhone' : 'homePhone');

      if (!otherValue) {
        callback('At least one phone is required.');
      } else {
        callback();
      }
    } else {
      callback();
    }
  }

  validateCity(rule, value, callback, source, options) {
    if (value === undefined || value === null || value === '') {
      callback('This field should not be empty.');
    } else {
      const pattern = /^[A-Za-z][A-Za-z ]*[A-Za-z]$/g;
      if (pattern.test(value)) {
        callback();
      } else {
        callback('City name is not valid.');
      }
    }
  }

  isInRenderableState() {
    return !!this.props.caregiver;
  }

  renderContent() {
    const { caregiver, form, ...layoutProps } = this.props;
    const { coordinators, teams, isSaveButtonEnable } = this.state;

    const { getFieldDecorator } = form;

    return (
      <FlexColContainer
        {...layoutProps}
        alignItems="center"
      >
        <styledComp.AntdForm
          width="match_parent"
          height="wrap_content"
          onSubmit={this.handleSubmit}
        >
          {/* Content */}
          <FlexColContainer
            width="match_parent"
            height="wrap_content"
            padding="20px 20px"
          >
            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              margin="0 0 20px 0"
            >
              <FlexRowContainer
                width="match_parent"
                height="wrap_content"
                margin="0 0 28px 0"
                justifyContent="space-between"
                alignItems="center"
              >
                <styledComp.Span
                  width="wrap_content"
                  height="wrap_content"
                  color="textPrimaryDark"
                  fontSize="24px"
                  fontWeight="300"
                >
                  Personal Info
                </styledComp.Span>

                <ChangeHistoriesButton
                  width="wrap_content"
                  height="wrap_content"
                  title="Change History"
                  table="Caregiver"
                  rowId={Number(this.id)}
                />
              </FlexRowContainer>

              <Row type="flex" gutter={24}>
                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="firstName"
                    label="First Name"
                    placeholder=""
                    initialValue={caregiver.getString('firstName')}
                    isRequired
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="middleName"
                    label="Middle Name"
                    placeholder=""
                    initialValue={caregiver.getString('middleName')}
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="lastName"
                    label="Last Name"
                    placeholder=""
                    initialValue={caregiver.getString('lastName')}
                    isRequired
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="gender"
                    label="Gender"
                    placeholder="Select..."
                    allowClear={false}
                    initialValue={caregiver.getString('gender')}
                    options={['Female', 'Male']}
                    isRequired
                  />
                </Col>

                <Col span={6}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="birth"
                    label="Date of Birth"
                    placeholder="mm/dd/yyyy"
                    extra="Select date from calendar"
                    initialValue={caregiver.getMoment('birth')}
                    isRequired
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="race"
                    label="Race"
                    placeholder="Select..."
                    allowClear
                    initialValue={caregiver.getString('race')}
                    options={[
                      'Hispanic or Latino',
                      'White (Not Hispanic or Latino)',
                      'Black or African American',
                      'Native Hawaiian or Pacific Islander',
                      'Asian',
                      'Native American or Alaska Native',
                      'Two or more races',
                      'Indeterminable race',
                    ]}
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="ssn"
                    label="Social Security Number (SSN)"
                    placeholder="111-11-1111"
                    inputMask="999-99-9999"
                    initialValue={caregiver.getString('ssn')}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="benefitCard"
                    label="Benefit Card"
                    placeholder="Select..."
                    initialValue={caregiver.getBoolean('benefitCard')?.toString()}
                    options={[{ value: 'false', text: 'No' }, { value: 'true', text: 'Yes' }]}
                  />
                </Col>
              </Row>
            </FlexColContainer>

            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              margin="0 0 20px 0"
            >
              <styledComp.Span
                width="wrap_content"
                height="wrap_content"
                margin="0 0 28px 0"
                color="textPrimaryDark"
                fontSize="24px"
                fontWeight="300"
              >
                Contact Info
              </styledComp.Span>

              <Row type="flex" gutter={24}>
                <Col span={12}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="street"
                    label="Street address and Suite or Apt. #"
                    placeholder="123 Main Street, Apt. 103"
                    extra="We currently only accept applications from New York."
                    initialValue={caregiver.getString('street')}
                    isRequired
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="city"
                    label="City"
                    placeholder=""
                    initialValue={caregiver.getString('city')}
                    validator={this.validateCity}
                  />
                </Col>

                <Col span={2}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="state"
                    label="State"
                    placeholder="Select..."
                    allowClear={false}
                    initialValue={caregiver.getString('state')}
                    options={['NY', 'NJ', 'CT']}
                    isRequired
                  />
                </Col>

                <Col span={4}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="zipCode"
                    label="ZIP Code"
                    placeholder=""
                    initialValue={caregiver.getString('zipCode')}
                    isRequired
                  />
                </Col>
              </Row>

              <Row type="flex" gutter={24}>
                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="homePhone"
                    label="Home Phone"
                    placeholder="(111) 111-1111"
                    inputMask="(999) 999-9999"
                    initialValue={caregiver.getString('homePhone')}
                    validator={this.validateAtLeastOnePhone}
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="cellPhone"
                    label="Cell Phone"
                    placeholder="(111) 111-1111"
                    inputMask="(999) 999-9999"
                    initialValue={caregiver.getString('cellPhone')}
                    validator={this.validateAtLeastOnePhone}
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="email"
                    label="Email"
                    placeholder="abc@abc.com"
                    initialValue={caregiver.getString('email')}
                  />
                </Col>
              </Row>
            </FlexColContainer>

            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              margin="0 0 20px 0"
            >
              <styledComp.Span
                width="wrap_content"
                height="wrap_content"
                margin="0 0 28px 0"
                color="textPrimaryDark"
                fontSize="24px"
                fontWeight="300"
              >
                Payroll Info
              </styledComp.Span>

              <Row type="flex" gutter={24}>
                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="coordinatorId"
                    label="Coordinator"
                    placeholder="Select..."
                    options={coordinators}
                    initialValue={caregiver.getLong('coordinatorId')}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="teamId"
                    label="Team"
                    placeholder="Select..."
                    options={teams}
                    initialValue={caregiver.getLong('teamId')}
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="pickupTeam"
                    label="Pickup Team"
                    placeholder=""
                    initialValue={caregiver.getString('pickupTeam')}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="paymentMethod"
                    label="Payment Method"
                    placeholder="Select..."
                    options={['Check', 'Direct Deposit']}
                    initialValue={caregiver.getString('paymentMethod')}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="maritalStatus"
                    label="Marital Status"
                    placeholder="Select..."
                    options={['Single', 'Married', 'Head of Household']}
                    initialValue={caregiver.getString('maritalStatus')}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="multipleJob"
                    label="Multiple Job"
                    placeholder="Select..."
                    allowClear={false}
                    options={[{ value: 'true', text: 'Yes' }, { value: 'false', text: 'No' }]}
                    initialValue={caregiver.getBoolean('multipleJob')?.toString()}
                  />
                </Col>

                <Col span={6}>
                  <FormInputNumber
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="dependent"
                    label="Dependent"
                    placeholder=""
                    min={0}
                    step={1}
                    precision={0}
                    initialValue={caregiver.getDouble('dependent')}
                  />
                </Col>

                <Col span={6}>
                  <FormInputNumber
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="otherIncome"
                    label="Other Income"
                    placeholder=""
                    min={0}
                    step={1}
                    precision={0}
                    initialValue={caregiver.getDouble('otherIncome')}
                  />
                </Col>

                <Col span={6}>
                  <FormInputNumber
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="deductAmount"
                    label="Deduction Amount"
                    placeholder=""
                    min={0}
                    step={1}
                    precision={0}
                    initialValue={caregiver.getDouble('deductAmount')}
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="allowance"
                    label="Allowance (Old Tax Format Only)"
                    placeholder=""
                    initialValue={caregiver.getString('allowance')}
                  />
                </Col>

                <Col span={6}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="i9Type"
                    label="I9 Type"
                    placeholder=""
                    initialValue={caregiver.getString('i9Type')}
                  />
                </Col>

                <Col span={6}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="i9ExpireDate"
                    label="I9 Expire Date"
                    placeholder="mm/dd/yyyy"
                    extra="Select date from calendar"
                    initialValue={caregiver.getMoment('i9ExpireDate')}
                  />
                </Col>

                <Col span={24}>
                  <FormTextArea
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="remark"
                    label="Remark"
                    rows={5}
                    max={2000}
                    extra="For internal use only, will not displayed to the caregiver."
                    initialValue={caregiver.getString('remark')}
                  />
                </Col>
              </Row>
            </FlexColContainer>

            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              margin="0 0 20px 0"
            >
              <styledComp.Span
                width="wrap_content"
                height="wrap_content"
                margin="0 0 28px 0"
                color="textPrimaryDark"
                fontSize="24px"
                fontWeight="300"
              >
                Physical Exam
              </styledComp.Span>

              <Row type="flex" gutter={24}>
                <Col span={6}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="physicalExamDate"
                    label="Physical Exam"
                    placeholder="mm/dd/yyyy"
                    extra="Select date from calendar"
                    initialValue={caregiver.getMoment('physicalExamDate')}
                  />
                </Col>

                {this.isMeRealAgency() &&
                  <Col span={6}>
                    <FormSelect
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="covidVaccine"
                      label="Covid-19 Vaccination"
                      placeholder="Select..."
                      extra="The vaccination status of this caregiver."
                      allowClear
                      options={[
                        { value: '0', text: '0 Dose' },
                        { value: '1', text: '1 Dose' },
                        { value: '2', text: '2 Doses' },
                        { value: '3', text: '3 Doses or More' },
                      ]}
                      initialValue={caregiver.getString('covidVaccine')}
                    />
                  </Col>
                }
              </Row>

              {this.isMeRealAgency() &&
                <Row type="flex" gutter={24}>
                  <Col span={6}>
                    <FormDatePicker
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="ppd1Date"
                      label="PPD#1"
                      placeholder="mm/dd/yyyy"
                      extra="Select date from calendar"
                      initialValue={caregiver.getMoment('ppd1Date')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormInput
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="ppd1"
                      label="PPD#1 Remark"
                      placeholder=""
                      extra="For internal note only."
                      initialValue={caregiver.getString('ppd1')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormDatePicker
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="ppd2Date"
                      label="PPD#2"
                      placeholder="mm/dd/yyyy"
                      extra="Select date from calendar"
                      initialValue={caregiver.getMoment('ppd2Date')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormInput
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="ppd2"
                      label="PPD#2 Remark"
                      placeholder=""
                      extra="For internal note only."
                      initialValue={caregiver.getString('ppd2')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormDatePicker
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="bloodTestDate"
                      label="QuantiFERON Blood Test"
                      placeholder="mm/dd/yyyy"
                      extra="Select date from calendar"
                      initialValue={caregiver.getMoment('bloodTestDate')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormInput
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="bloodTest"
                      label="QuantiFERON Blood Test Remark"
                      placeholder=""
                      extra="For internal note only."
                      initialValue={caregiver.getString('bloodTest')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormDatePicker
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="cxrReportDate"
                      label="CXR Report"
                      placeholder="mm/dd/yyyy"
                      extra="Select date from calendar"
                      initialValue={caregiver.getMoment('cxrReportDate')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormInput
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="cxrReport"
                      label="CXR Report Remark"
                      placeholder=""
                      extra="For internal note only."
                      initialValue={caregiver.getString('cxrReport')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormDatePicker
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="drugTestDate"
                      label="Drug Test"
                      placeholder="mm/dd/yyyy"
                      extra="Select date from calendar"
                      initialValue={caregiver.getMoment('drugTestDate')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormInput
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="drugTest"
                      label="Drug Test Remark"
                      placeholder=""
                      extra="For internal note only."
                      initialValue={caregiver.getString('drugTest')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormDatePicker
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="fluVaccineDate"
                      label="Flu Vaccine"
                      placeholder="mm/dd/yyyy"
                      extra="Select date from calendar"
                      initialValue={caregiver.getMoment('fluVaccineDate')}
                    />
                  </Col>

                  <Col span={6}>
                    <FormDatePicker
                      width="match_parent"
                      height="wrap_content"
                      form={form}
                      name="fluVaccineDeclinationDate"
                      label="Flu Vaccine Declination"
                      placeholder="mm/dd/yyyy"
                      extra="Select date from calendar"
                      initialValue={caregiver.getMoment('fluVaccineDeclinationDate')}
                    />
                  </Col>
                </Row>
              }
            </FlexColContainer>

            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              margin="0 0 20px 0"
            >
              <styledComp.Span
                width="wrap_content"
                height="wrap_content"
                margin="0 0 28px 0"
                color="textPrimaryDark"
                fontSize="24px"
                fontWeight="300"
              >
                Caregiver Details
              </styledComp.Span>

              <Row type="flex" gutter={24}>
                <Col span={6}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="startWorkDate"
                    label="Start Working Date"
                    placeholder="mm/dd/yyyy"
                    extra="Select date from calendar"
                    initialValue={caregiver.getMoment('startWorkDate')}
                  />
                </Col>

                <Col span={6}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="endWorkDate"
                    label="End Working Date"
                    placeholder="mm/dd/yyyy"
                    extra="Select date from calendar"
                    initialValue={caregiver.getMoment('endWorkDate')}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="waiting"
                    label="Is Waiting"
                    placeholder="Select..."
                    extra="Is the caregiver waiting to work."
                    allowClear={false}
                    initialValue={caregiver.getBoolean('waiting')?.toString()}
                    options={[{ value: 'true', text: 'Yes' }, { value: 'false', text: 'No' }]}
                    isRequired
                  />
                </Col>

                <Col span={6}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="inServiceTrainingDate"
                    label="Latest In-Service Training Date"
                    placeholder="mm/dd/yyyy"
                    extra="Select date from calendar"
                    initialValue={caregiver.getMoment('inServiceTrainingDate')}
                  />
                </Col>
              </Row>

              <Row type="flex" gutter={24}>
                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="drive"
                    label="Drive"
                    placeholder="Select..."
                    initialValue={caregiver.getBoolean('drive')?.toString()}
                    options={[{ value: 'true', text: 'Yes' }, { value: 'false', text: 'No' }]}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="certification"
                    label="Has Certification"
                    placeholder="Select..."
                    initialValue={caregiver.getBoolean('certification')?.toString()}
                    options={[{ value: 'true', text: 'Yes' }, { value: 'false', text: 'No' }]}
                  />
                </Col>

                <Col span={6}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="antiSexualTraining"
                    label="Anti-sexual Harassment Training"
                    placeholder="Select..."
                    initialValue={caregiver.getBoolean('antiSexualTraining')?.toString()}
                    options={[{ value: 'true', text: 'Yes' }, { value: 'false', text: 'No' }]}
                  />
                </Col>

                <Col span={6}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="orientationDate"
                    label="Latest Orientation Date"
                    placeholder="mm/dd/yyyy"
                    extra="Select date from calendar"
                    initialValue={caregiver.getMoment('orientationDate')}
                  />
                </Col>

                <Col span={12}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Languages which this caregiver can speak"
                  >
                    <FlexRowContainer
                      width="match_parent"
                      height="wrap_content"
                      padding="6px 12px"
                      border="1px solid controlBorder"
                    >
                      {getFieldDecorator('languages', {
                        rules: [],
                        initialValue: caregiver.getStrings('languages'),
                      })(
                        <Checkbox.Group style={{ width: '100%' }}>
                          <Row type="flex" gutter={24}>
                            <Col span={8}>
                              <Checkbox value="English">English</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Mandarin">Mandarin</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Cantonese">Cantonese</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Spanish">Spanish</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Japanese">Japanese</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Korean">Korean</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Russian">Russian</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Vietnamese">Vietnamese</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Fujianese">Fujianese</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Mingnan">Mingnan</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Shanghainese">Shanghainese</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Taisanese">Taisanese</Checkbox>
                            </Col>
                            <Col span={24}>
                              <Checkbox value="Other">Other (Please specify in self description.)</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>,
                      )}
                    </FlexRowContainer>
                  </styledComp.AntdFormItem>
                </Col>

                <Col span={12}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Interested Work Areas"
                  >
                    <FlexRowContainer
                      width="match_parent"
                      height="wrap_content"
                      padding="6px 12px"
                      border="1px solid controlBorder"
                    >
                      {getFieldDecorator('preferAreas', {
                        rules: [],
                        initialValue: caregiver.getStrings('preferAreas'),
                      })(
                        <Checkbox.Group style={{ width: '100%' }}>
                          <Row type="flex" gutter={24}>
                            <Col span={8}>
                              <Checkbox value="Queens">Queens</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Brooklyn">Brooklyn</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Bronx">Bronx</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Long Island">Long Island</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Manhattan">Manhattan</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Staten Island">Staten Island</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Albany">Albany</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Erie">Erie</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Orange">Orange</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Nassau">Nassau</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Rockland">Rockland</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Suffolk">Suffolk</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Ulster">Ulster</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Westchester">Westchester</Checkbox>
                            </Col>
                            <Col span={8}>
                              <Checkbox value="Niagara">Niagara</Checkbox>
                            </Col>
                            <Col span={24}>
                              <Checkbox value="Other">Other (Please specify in self description.)</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>,
                      )}
                    </FlexRowContainer>
                  </styledComp.AntdFormItem>
                </Col>

                <Col span={12}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Available Shifts"
                  >
                    <FlexRowContainer
                      width="match_parent"
                      height="wrap_content"
                      padding="6px 12px"
                      border="1px solid controlBorder"
                    >
                      {getFieldDecorator('preferShifts', {
                        rules: [],
                        initialValue: caregiver.getStrings('preferShifts'),
                      })(
                        <Checkbox.Group style={{ width: '100%' }}>
                          <Row type="flex" gutter={24}>
                            <Col span={6}>
                              <Checkbox value="Days">Days</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Evenings">Evenings</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Nights">Nights</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>,
                      )}
                    </FlexRowContainer>
                  </styledComp.AntdFormItem>
                </Col>

                <Col span={12}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Can Work for"
                  >
                    <FlexRowContainer
                      width="match_parent"
                      height="wrap_content"
                      padding="6px 12px"
                      border="1px solid controlBorder"
                    >
                      {getFieldDecorator('preferEmploymentTypes', {
                        rules: [],
                        initialValue: caregiver.getStrings('preferEmploymentTypes'),
                      })(
                        <Checkbox.Group style={{ width: '100%' }}>
                          <Row type="flex" gutter={24}>
                            <Col span={6}>
                              <Checkbox value="Full-time">Full-time</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Part-time">Part-time</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Live-in">Live-in</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Live-out">Live-out</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>,
                      )}
                    </FlexRowContainer>
                  </styledComp.AntdFormItem>
                </Col>

                <Col span={12}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Available Days"
                  >
                    <FlexRowContainer
                      width="match_parent"
                      height="wrap_content"
                      padding="6px 12px"
                      border="1px solid controlBorder"
                    >
                      {getFieldDecorator('preferDays', {
                        rules: [],
                        initialValue: caregiver.getStrings('preferDays'),
                      })(
                        <Checkbox.Group style={{ width: '100%' }}>
                          <Row type="flex" gutter={24}>
                            <Col span={6}>
                              <Checkbox value="Monday">Monday</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Tuesday">Tuesday</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Wednesday">Wednesday</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Thursday">Thursday</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Friday">Friday</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Saturday">Saturday</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Sunday">Sunday</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>,
                      )}
                    </FlexRowContainer>
                  </styledComp.AntdFormItem>
                </Col>

                <Col span={12}>
                  <styledComp.AntdFormItem
                    width="match_parent"
                    height="wrap_content"
                    label="Skills"
                  >
                    <FlexRowContainer
                      width="match_parent"
                      height="wrap_content"
                      padding="6px 12px"
                      border="1px solid controlBorder"
                    >
                      {getFieldDecorator('skills', {
                        rules: [],
                        initialValue: caregiver.getStrings('skills'),
                      })(
                        <Checkbox.Group style={{ width: '100%' }}>
                          <Row type="flex" gutter={24}>
                            <Col span={6}>
                              <Checkbox value="Cleaning">Cleaning</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Cooking">Cooking</Checkbox>
                            </Col>
                            <Col span={6}>
                              <Checkbox value="Communication">Communication</Checkbox>
                            </Col>
                            <Col span={24}>
                              <Checkbox value="Other">Other (Please specify in self description.)</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>,
                      )}
                    </FlexRowContainer>
                  </styledComp.AntdFormItem>
                </Col>

                <Col span={24}>
                  <FormTextArea
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="descriptions"
                    label="Self Description"
                    rows={3}
                    max={2000}
                    initialValue={caregiver.getString('descriptions')}
                  />
                </Col>
              </Row>
            </FlexColContainer>

            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              margin="0 0 20px 0"
            >
              <styledComp.Span
                width="wrap_content"
                height="wrap_content"
                margin="0 0 28px 0"
                color="textPrimaryDark"
                fontSize="24px"
                fontWeight="300"
              >
                Caregiver Application
              </styledComp.Span>

              <Row type="flex" gutter={24}>
                <Col span={12}>
                  <FormTextArea
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="noteFromCaregiver"
                    label="Additional Message from Caregiver"
                    rows={3}
                    max={2000}
                    disabled
                    initialValue={caregiver.getString('noteFromCaregiver')}
                  />
                </Col>

                <Col span={12}>
                  <FormTextArea
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="noteFromStaff"
                    label="Additional Message to Caregiver"
                    rows={3}
                    max={2000}
                    initialValue={caregiver.getString('noteFromStaff')}
                  />
                </Col>

                <Col span={12}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="applyStatus"
                    label="Apply Status"
                    placeholder="Select..."
                    extra="The status of this caregiver application."
                    allowClear={false}
                    options={['PROCESSING', 'APPROVED', 'REJECTED', 'CANCELED', 'ON_HOLD']}
                    initialValue={caregiver.getString('applyStatus')}
                    isRequired
                  />
                </Col>

                <Col span={12}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="applyDate"
                    label="Apply Date"
                    placeholder=""
                    disabled
                    initialValue={caregiver.getString('applyDateUsString')}
                    isRequired
                  />
                </Col>
              </Row>
            </FlexColContainer>
          </FlexColContainer>

          {/* Footer */}
          <FlexRowContainer
            width="match_parent"
            height="wrap_content"
            padding="20px 20px"
            justifyContent="center"
            backgroundColor="containerGrayBackground"
          >
            <CustomButton
              width="wrap_content"
              height="32px"
              margin="0 4px 0 0"
              backgroundColor="green_haze"
              fontSize="14px"
              type="primary"
              loading={!isSaveButtonEnable}
              htmlType="submit"
            >
              SAVE
            </CustomButton>

            <styledComp.AntdButton
              width="wrap_content"
              height="32px"
              fontSize="14px"
              type="default"
              onClick={this.onResetClick}
            >
              RESET
            </styledComp.AntdButton>
          </FlexRowContainer>
        </styledComp.AntdForm>
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
CaregiverDetails.propTypes = propTypes;

export default Form.create()(CaregiverDetails);
